const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#e86747"
    },
    points: "255.84,363.128 212.208,337.232 3.936,214.176 3.936,512  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#e86747"
    },
    points: "256.264,363.28 507.944,512 507.944,214.248 462.6,241.024 462.6,240.976 462.48,241.048  462.48,241.256  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#e86730"
    },
    points: "256.176,363.328 255.856,363.136 3.936,512 507.944,512 256.264,363.28 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EFEFEF"
    },
    points: "255.856,363.136 256.176,363.328 256.264,363.28 462.48,241.256 462.48,241.048  462.48,61.864 397.408,61.888 222.072,274.936 111.64,167.528 153.568,122.032 217.16,183.888 317.536,61.912 49.52,62  49.52,240.664 212.208,337.232 255.84,363.128 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#e86730"
    },
    points: "49.4,179.816 3.936,214.176 49.4,241.024  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#e86730"
    },
    points: "507.944,214.248 508.064,214.176 462.6,179.816 462.6,240.976 462.6,241.024  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#8AD5DD"
    },
    points: "153.568,122.032 111.64,167.528 222.072,274.936 397.408,61.888 415.048,40.448 368.48,0  317.536,61.912 217.16,183.888 "
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.6d3ac56e8ca9d6cebb5c1232690088ef.svg";
export { ForwardRef as ReactComponent };